import React, { useState, useEffect } from "react";
import { useToast } from "../../components/toast/ToastContainer";
import { useAxios } from "../../http-client/AxiosContext";
import { usePageHeader } from "../../hooks/PageHeaderContext";
import { useIsDesktop } from "../../hooks/useIsDesktop";
import Button from "../ui/Button";

const FIELD =
  "tw:w-full tw:appearance-none tw:rounded-xl tw:border tw:border-glassborder tw:bg-surface tw:px-3 tw:py-2 tw:text-sm tw:text-text! tw:outline-none tw:focus:border-accent";

const PrintTicketForm = () => {
  const [quantity, setQuantity] = useState(1);
  const [loading, setLoading] = useState(false);
  const [isPrinterHealthy, setIsPrinterHealthy] = useState(false);
  const { addToast } = useToast();
  const { ax, axReady } = useAxios();

  const isDesktop = useIsDesktop();
  usePageHeader(isDesktop ? "Inicio" : null, null, [isDesktop]);

  useEffect(() => {
    if (!axReady || !ax) {
      return;
    }

    const checkPrinterHealth = async () => {
      try {
        const response = await ax.get("/printer/health/");
        if (response.data?.status === "OK" || response.status === 200) {
          setIsPrinterHealthy(true);
        } else {
          setIsPrinterHealthy(false);
        }
      } catch (error) {
        console.error("Error checking printer health:", error);
        setIsPrinterHealthy(false);
      }
    };
    checkPrinterHealth();
  }, [axReady, ax]);

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    setLoading(true);
    try {
      await ax.get(`/printer/print/${quantity}/`);
      addToast("La impresion se completó", "success");
    } catch (error) {
      console.error("Error printing ticket:", error);
      addToast("Fallo en la impresión", "danger");
    } finally {
      setLoading(false);
    }
  };

  const handleSetQuantity = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (Number(e.target.value) > 0) {
      setQuantity(Number(e.target.value));
    }
  };

  return (
    <div className="tw:space-y-4 tw:pb-24 tw:lg:pb-0">
      <section className="tw:max-w-md tw:space-y-3 tw:rounded-2xl tw:border tw:border-glassborder tw:bg-surface tw:p-4">
        <h2 className="tw:text-sm tw:font-semibold tw:text-text">
          Imprimir tickets en blanco
        </h2>
        <form onSubmit={handleSubmit} className="tw:space-y-3">
          <div className="tw:space-y-1">
            <label htmlFor="quantity" className="tw:text-xs tw:text-text-muted">
              Cantidad
            </label>
            <input
              type="number"
              id="quantity"
              value={quantity}
              onChange={handleSetQuantity}
              className={FIELD}
            />
          </div>
          <Button
            type="submit"
            disabled={!axReady || !isPrinterHealthy || loading}
          >
            {loading ? "Imprimiendo..." : "Imprimir"}
          </Button>
          {!isPrinterHealthy && (
            <p className="tw:text-sm tw:text-rose-500">
              La impresora no está disponible
            </p>
          )}
        </form>
      </section>
    </div>
  );
};

export default PrintTicketForm;
